export default "__VITE_ASSET__DMAGyrYg__"